module.exports = __webpack_public_path__ + "static/media/Channel-Rogers-Xfinity.6ca88362.webp";